module.exports = __webpack_public_path__ + "img/ChalkboardTeacher.33290b8b.svg";